export enum ClaimType {
  Authority = "https://claims.whitespacews.com/authorityid",
  Region = "https://claims.whitespacews.com/regionid",
  Role = "https://claims.whitespacews.com/roleid",
  HwrcSite = "https://claims.whitespacews.com/hwrcsiteid"
}
